import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeFileUploadComponent } from '../shared/file-upload/employee-file-upload.component';
import { SharedModule } from '../shared/shared.module';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { UserRequestComponent } from './components/user-request/user-request.component';
import { UserRoutingModule } from './user-routing.module';
import { UserComponent } from './user.component';
import { EmpAdditionalUploadComponent } from './components/emp-additional-upload/emp-additional-upload.component';



@NgModule({
    declarations: [UserComponent, UserProfileComponent, EmployeeFileUploadComponent, UserRequestComponent, EmpAdditionalUploadComponent],
    imports: [
        UserRoutingModule,
        SharedModule,
        CommonModule,
        //NgbTabsetModule
    ],
    exports: [UserProfileComponent, EmpAdditionalUploadComponent],
    providers: [NgbActiveModal]
})
export class UserModule { }
